import axios, { AxiosRequestConfig, CancelToken, AxiosResponse, AxiosPromise, AxiosError } from 'axios'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import { RequestErrorCodeEnum, IResponseResult, RequestErrorMessageMap, IResponseError } from './requestConst'
import config from '@/config'
import { UserModule } from '@/store/modules/user'
import md5 from 'js-md5'

interface RequestOptions {
  /** 公共参数配置 */
  publicConfig?: () => RequestPublicConfig
  /** 不处理响应返回的错误 */
  notHandleResponseErrorApiList?: string[]
}
interface RequestPublicConfig {
  /** 整个axios实例 baseURL */
  baseURL?: string
  /** 根据请求方法设置参数(data OR params) */
  params?: object
  /** 公用请求头设置，如Auth Token */
  headers?: object
}
interface IPendingRequest {
  url: string
  cancelMethod: () => void
}
/**
/** 防止重复请求接口列表 */
const preventDuplicateUrlList: string[] = []
const pengdingRequestList: IPendingRequest[] = []

/** 默认配置 */
let requestOptions: RequestOptions = {
  notHandleResponseErrorApiList: [],
  publicConfig: () => {
    const timeStamp = Date.now()
    // console.log(`${UserModule.name}${UserModule.token}${timeStamp}${UserModule.staticKey}`);
    // console.log(md5('hgd202310114020263d-91ef-4cf1-83af-5a58d1cbe3d816970928674511111111'))
    return {
      params: {},
      baseURL: config.apiBaseUrl,
      headers: {
        Name: UserModule.name,
        Token: UserModule.token,
        'Time-Stamp': timeStamp,
        platform: 'manageWeb',
        Sign: md5(`${UserModule.name}${UserModule.token}${timeStamp}${UserModule.staticKey}`),
      }
      // responseType: 'blob'
    }
  },
}
export function initHttp(options: RequestOptions) {
  requestOptions = { ...requestOptions, ...options }
  
}

function cancelPengdingRequest(requestConfig: AxiosRequestConfig) {
  for (let i = pengdingRequestList.length - 1; i >= 0; i--) {
    const pengdingRequest: IPendingRequest = pengdingRequestList[i]
    if (!requestConfig || requestConfig.url === pengdingRequest.url) {
      console.debug('cancel duplicate request', requestConfig.url)
      pengdingRequest.cancelMethod()
      pengdingRequestList.splice(i, 1)
    }
  }
}
/** 防止轮询重复建立DOM */
let MessageBoxOpen: any = null
function showLoginTip() {
  if (!MessageBoxOpen) {
    MessageBoxOpen = MessageBox.confirm('登录状态失效，你可以取消继续留在该页面，或者重新登录', '登录状态提示', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        router.push({ name: 'Login', query: { redirect: router.currentRoute.path } })
      })
      .finally(() => {
        MessageBoxOpen = null
      })
  }
}

function handleRequestError(error: IResponseError) {
  // console.log(error);
  
  if (error.code === RequestErrorCodeEnum.PERMISSION_NOT_LOGIN) {
    if (UserModule.isLogin) {
      showLoginTip()
    }
    // showLoginTip()
    // router.push({ name: 'Login', query: { redirect: router.currentRoute.path } })
  } else {
    // console.log(error);
    Message({
      message: RequestErrorMessageMap[error.code] || error.msg || '服务器错误',
      type: 'error',
      duration: 3 * 1000,
    })
  }
}
const service = axios.create({
  timeout: 10000,
  withCredentials: true,
})

/** 设置公共参数 */
function setPublicParams(axiosConfig: AxiosRequestConfig) {
  let { method = 'GET', data = {}, params = {}, headers = {}, baseURL = '',responseType='json' } = axiosConfig
  let { params: _params = {}, baseURL: _baseURL = '', headers: _headers = {} ,responseType: _responseType='json' } = requestOptions.publicConfig!()
  axiosConfig.baseURL = baseURL || _baseURL
  axiosConfig.headers = {
    ..._headers,
    ...headers,
  }
  axiosConfig.responseType = responseType || _responseType
  if (String(method).toUpperCase() === 'GET') {
    axiosConfig.params = { ..._params, ...params }
  } else {
    if (Object.prototype.toString.call(data) === '[object FormData]') {
      Object.entries(_params).forEach(([key, val]) => {
        if (!data.get(key)) {
          data.append(key, val)
        }
      })
    } else {
      axiosConfig.data = { ..._params, ...data }
    }
  }
}

// Request interceptors
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // console.log(12);
    
    // console.log(config);
    
    setPublicParams(config)
    if (preventDuplicateUrlList.indexOf(config.url as string) !== -1) {
      cancelPengdingRequest(config)
      config.cancelToken = new axios.CancelToken((cancelMethod: () => void) => {
        pengdingRequestList.push({ url: config.url as string, cancelMethod })
      })
    }
    // 上传文件，限制formData不转换stringify
    // if (!(config as any).isFormData) {
    //   config.data = qs.stringify(config.data)
    // }
    return config
  },
  error => {
    Promise.reject(error)
  },
)

// Response interceptors
service.interceptors.response.use(
  response => response,
  error => {
    if (error.message && error.message.indexOf('timeout of') === 0) {
      error.code = RequestErrorCodeEnum.TIMEOUT
      error.message = RequestErrorMessageMap[RequestErrorCodeEnum.TIMEOUT]
    }
    console.log(error);
    
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  },
)

export function commonRequest(option: AxiosRequestConfig):Promise<any> {
  return new Promise((resolve, reject) => {
    service.request(option).then((response) => {
      const data: IResponseResult = response.data
      // console.log(option);
      // console.log(response);
      if(response.config.responseType === 'blob'){
        // console.log(response.data);
      console.log(option);

        
      
            resolve(response)

      }
   
      
      
      
      else {
        if (!data.success) {
        if (!requestOptions.notHandleResponseErrorApiList!.some(path => response.config.url!.includes(path))) {
          handleRequestError(response.data)
        }
        return reject(response)
      }
      resolve(data.data)
    }
    }).catch((err: AxiosError) => {
      reject(err)
    })
  })
}

export default service
